// import packages
import React, { useContext } from "react";
import { Button, TextField, Select, InlineStack } from "@shopify/polaris";

// import context
import { PrivateContext } from "lib/context";

import constant from "lib/constant/constant";

const OrderTax = (props) => {
  const { count, removeItem, updateRateVal, vendorOptions, taxes } = props;
  const {
    color: { RED },
  } = constant;
  const { cms = {} } = useContext(PrivateContext);

  const arr = Array.from(Array(count).keys());
  return arr.map((item) => {
    const taxItem = taxes[item];
    if (!taxItem) {
      return null;
    }

    const vendorSelect = `${constant.VENDOR_SELECT}${item}`;
    const taxClassText = `${constant.TAX_CLASS_TEXT}${item}`;
    const rateText = `${constant.RATE_TEXT}${item}`;

    return (
      <div key={item}>
        <InlineStack wrap={false} key={item} gap="10" align="space-between" blockAlign="center">
          <div className="formWidth180px">
            <TextField
              placeholder={cms("placeholder.name")}
              id={taxClassText}
              type="text"
              onChange={(val) => {
                updateRateVal(constant.TAX_CLASS, val, item);
              }}
              value={(taxItem && taxItem.taxClass) || ""}
            />
          </div>
          <div className="formWidth180px">
            <Select
              id={vendorSelect}
              placeholder={cms("placeholder.selectVendor")}
              options={vendorOptions}
              onChange={(val) => {
                updateRateVal(constant.VENDOR_ID, val, item);
              }}
              value={(taxItem && taxItem.vendorId) || ""}
            />
          </div>
          <div className="formWidth180px">
            <TextField
              placeholder={cms("placeholder.rate")}
              type="number"
              id={rateText}
              suffix="%"
              value={(taxItem && taxItem.rate && taxItem.rate.toString()) || ""}
              onChange={(val) => {
                updateRateVal(constant.RATE, val, item);
              }}
            />
          </div>
          <Button id="deleteButton" plain onClick={() => removeItem(item)}>
            <i className="far fa-trash fa-lg" style={{ color: RED }} />
          </Button>
        </InlineStack>
        <br />
      </div>
    );
  });
};

export default OrderTax;
